import styled from "react-emotion";

export const Wrapper = styled.div`
  display: flex;
  gap: 2.5rem;
  align-content: center;
`;
